import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Phone, MessageSquare } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import TestimonialCard from '../components/TestimonialCard';
import { companyInfo, testimonials } from '../data/mock';

const Avis = () => {
  return (
    <div className="min-h-screen pt-24">
      {/* Header */}
      <section className="py-12 bg-gradient-to-br from-[#0B2A4A]/5 via-white to-[#2F80ED]/5">
        <div className="container mx-auto px-4">
          <Badge className="bg-[#2F80ED] text-white mb-4">Avis clients</Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-[#0B2A4A] mb-6">
            Ce que disent nos clients
          </h1>
          <div className="flex items-center gap-4 mb-4">
            <div className="flex items-center gap-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-8 h-8 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <div>
              <p className="text-3xl font-bold text-[#0B2A4A]">{companyInfo.rating} / 5</p>
              <p className="text-gray-600">Basé sur {companyInfo.reviewCount} avis Google</p>
            </div>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl leading-relaxed">
            La satisfaction de nos clients est notre priorité. Découvrez leurs témoignages 
            authentiques sur la qualité de nos interventions.
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} testimonial={testimonial} />
            ))}
          </div>

          {/* Leave Review */}
          <div className="max-w-3xl mx-auto bg-gradient-to-br from-[#0B2A4A] to-[#2F80ED] rounded-2xl p-8 text-white text-center">
            <MessageSquare className="w-12 h-12 mx-auto mb-4" />
            <h3 className="text-2xl font-bold mb-3">
              Vous avez fait appel à nos services ?
            </h3>
            <p className="text-gray-100 mb-6">
              Votre avis compte ! Partagez votre expérience pour aider d'autres personnes 
              à faire le bon choix et nous aider à améliorer nos services.
            </p>
            <Button 
              size="lg" 
              className="bg-white text-[#0B2A4A] hover:bg-gray-100 gap-2 transition-all duration-300"
            >
              Laisser un avis sur Google
            </Button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold text-[#2F80ED] mb-2">
                {companyInfo.rating}/5
              </div>
              <p className="text-gray-600 font-semibold">Note moyenne</p>
              <div className="flex justify-center gap-1 mt-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#2F80ED] mb-2">
                {companyInfo.reviewCount}
              </div>
              <p className="text-gray-600 font-semibold">Avis clients</p>
              <p className="text-sm text-gray-500 mt-2">Sur Google My Business</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#2F80ED] mb-2">
                10+
              </div>
              <p className="text-gray-600 font-semibold">Années d'expérience</p>
              <p className="text-sm text-gray-500 mt-2">À Lyon et environs</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-[#0B2A4A] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Rejoignez nos clients satisfaits
          </h2>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Faites confiance à un professionnel reconnu pour la qualité de son travail.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={`tel:${companyInfo.phoneFormatted}`}>
              <Button size="lg" className="bg-[#2F80ED] hover:bg-white hover:text-[#0B2A4A] gap-2 transition-all duration-300">
                <Phone className="w-5 h-5" />
                {companyInfo.phone}
              </Button>
            </a>
            <Link to="/contact">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-[#0B2A4A] transition-all duration-300">
                Demander un devis
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Avis;
